import { render, staticRenderFns } from "./prologinbottomsheet.vue?vue&type=template&id=72abc512&scoped=true"
import script from "./prologinbottomsheet.vue?vue&type=script&lang=js"
export * from "./prologinbottomsheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72abc512",
  null
  
)

export default component.exports